module.exports = __webpack_public_path__ + "img/code2.6a233e64.png";